import React from 'react';
import { AutScanDataItem, } from '../../../../utils/models';

import CustomGroupItem from '../../custom-general/custom-group-item';
import AUTScanDataItemEditForm from '../../../forms/custom-aut/scan-data/autScanDataItemEditForm';

interface AUTScanItemProps {
    onDeleteScanItem: (item: AutScanDataItem) => void;
    onEditScanItem: (updatedItem: AutScanDataItem) => void;
    initialData: AutScanDataItem;
    isOpenOnDefault: boolean;
}

const AutScanItem: React.FC<AUTScanItemProps> = ({ isOpenOnDefault, onDeleteScanItem, initialData, onEditScanItem }) => {
    return ( 
        <CustomGroupItem 
            isOpenOnDefault={isOpenOnDefault} 
            onDelete={() => onDeleteScanItem(initialData)} 
            title={initialData.zoneName} 
            onEdit={() => null}
        >
            <AUTScanDataItemEditForm initialData={initialData} onEdit={onEditScanItem} />
        </CustomGroupItem>
     );
}
 
export default AutScanItem;